/* ==========================================================================
  Main.js
========================================================================== */

(function($) {

  // Aucor navigation
  $(document).ready(function(){
    $('#site-navigation').aucor_navigation({
      desktop_min_width: 501,     // min width in pixels
      menu_toggle: "#menu-toggle" // selector for toggle
    });
  });

  // Responsive videos
  fitvids();

  // Toggle search form on mobile
  $(document).ready(function(){
    $('.site-header .search-field').on('focus', function(){
      $(this).parents('.site-actions-search').addClass('active');
    });

    $('.site').on('click', function(){
      $('.site-actions-search').removeClass('active');
    });
  });

  $(document).ready(function(){
    // Add class for quick nav to animate once per session
    if (sessionStorage){
      if (!sessionStorage.getItem('current_session')) {
        $('.quick-nav').addClass('animate');
      }

      sessionStorage.setItem('current_session', true);
    }

    // Limit quick nav movement to content area
    var nav_pos = function() {
      var nav = $('.quick-nav');
      var content = $('#content');
      var nav_max = content.outerHeight(true) - content.position().top - nav.height();
  
      $(window).scroll(function(e){
        var pos = $(this).scrollTop();
  
        if (pos >= nav_max) {
          nav.css({
            'top': nav_max + nav.height() - 30,
            'position': 'absolute'
          });
        } else {
          nav.css({
            'top': '',
            'position': ''
          });
        }
      });
    };
    
    //nav_pos();
    
    $(window).resize(function(){
      //nav_pos();
    });

    // FAQ accordion
    $('.faq').on('click', '.entry-header', function(){
      $(this).next('.entry-content').slideToggle(200).parent('.faq').toggleClass('active');
    });

    // Read more
    $('.read-more').on('click', '.read-more-toggle', function(){
      $(this).next('.read-more-content').slideToggle(200).parent('.read-more').toggleClass('active');
    });

    $('.read-more').each(function(){
      if ($(this).next('.read-more').length == 0 && $(this).prev('.read-more').length == 0) {
        $(this).addClass('read-more--singular');
      }
    });
  });

})(jQuery);
